import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import {Linkedin, Twitter} from './SocialsIcons'

const SocialsContainer = styled.div`
	display: flex;
	margin: -.6rem;
	transform: scale(1);
	a {
		transition: ${props => props.theme.transitions.smallElements};
		
		&:hover {
			transform: scale(1.2);
		}
	}
	
	> * {
		margin: .6rem;
	}
	
	svg {
		fill: ${props => props.theme.colors.main};
		height:1rem; 
	}
`


function Socials({className, data}) {
	if (!data || (!data.twitter && !data.linkedin)) return null

	return <SocialsContainer className={className}>
		{!!data.twitter && <a href={data.twitter} rel="noopener noreferrer" target='_blank'>
			<Twitter/>
		</a>}
		{!!data.linkedin && <a href={data.linkedin} rel="noopener noreferrer" target='_blank'>
			<Linkedin/>
		</a>}
	</SocialsContainer>
}

Socials.propTypes = {
	className: PropTypes.string,
	data: PropTypes.shape({
		twitter: PropTypes.string,
		linkedin: PropTypes.string,
	}).isRequired,
}

Socials.defaultProps = {
	className: '',
}

export default Socials
